/*
  曹秀芳
  2019.09.06
  制作车间大屏页面
*/ 
<template>
	<div class="content">
		<div class="header">
			<div class="header-left">{{time}}</div>
			<div class="header-middle">{{$t('platform.title')}}</div>
			<div class="header-right">
				<span @click="langChage(0)" :class="{purple:$store.state.lang !==1,show:true}">EN</span> / <span :class="{purple:$store.state.lang ===1,show:true}" @click="langChage(1)">中</span>
			</div>
		</div>
		<div class="body">
			<div class="body-left">
				<div>
					<div class="left-item-title">{{$t('platform.Reloading')}}</div>
					<div class="left-item-content">

						<div v-for="(it,index) in statistics" :key="index">
							<div v-show="$store.state.lang === 1" class="statistics-item-title">{{it.codeName.description}}</div>
							<div v-show="$store.state.lang === 0" class="statistics-item-title">{{it.codeName.descriptionEn}}</div>
							<div class="statistics-item">

								<div class="flexo" v-for="(item,index) in it.beforeList" :key="item.lastTime">
									<div class="fract">
										<div :class="{blue:index<3,yellow:index>=3}">{{item.percentage}}</div><div>{{item.lastTime | formatDateTime}}</div>
									</div>
									<div class="division">/</div>
								</div>

								<div class="flexo" v-for="(item,index) in it.forList" :key="item.lastTime">
									<div class="fract">
										<div :class="{yellow:index<3,blue:index>=3}">{{item.percentage}}</div><div>{{item.lastTime | formatDateTime}}</div>
									</div>
									<div v-if="index !== 2" class="division">/</div>
								</div>

								<div class="chart-p">
									<div class="chart-absolute">
										<div class="chart" :id="'chartOne'+(index+1)" ref="chartOne" :style="{width:'1.8rem',height:'2rem'}"></div>
										<div class="chart2" :id="'chartTwo'+(index+1)" ref="chartTwo" :style="{width:'1.8rem',height:'2rem'}"></div>
									</div>
								</div>
								<div class="Percentage">{{parseInt(it.pert*100)}}%</div>
								<!-- <div class="Percentage">{{parseInt(Math.random()*100)}}%</div> -->
							</div>
						</div>

					</div>
				</div>
				<div>
					<div class="left-item-title">{{$t('platform.TotalTime')}}</div>
					<div class="leftLowerBody">
						<div class="chartTotal">
							<!-- <div class="allTime">
								<div class="TotalTime">Total Time</div>
								<div>{{allTime}}</div>
							</div> -->
							<div id="echartsTotal" :style="{width:'28rem',height:'22rem'}"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="body-middle">
				<div>
					<div class="middleTop-title">
						<div class="middleTopTitle-one middleTopTitle">{{$t('platform.equipment')}}: {{machines.length}}</div>
						<div class="middleTopTitle-two middleTopTitle">{{$t('platform.running')}}: {{run.length}}</div>
						<div class="middleTopTitle-four middleTopTitle">{{$t('platform.fault')}}: {{err.length}}</div>
						<div class="middleTopTitle-five middleTopTitle">{{$t('platform.tooling')}}: {{tool.length}}</div>
					</div>
					<div class="middleTop-body">
						<div class="middleTopBody-item" v-for="(item,index) in machines" :key="index+10">
							<div>
								<img style="width:8rem; height:5rem; margin:0.4rem 0;" :src="images[item.machineStatus]"/>
							</div>	
							<div v-show="$store.state.lang === 1" class="type">{{item.nameZh}}</div>
							<div v-show="$store.state.lang === 0" class="type">{{item.nameEn}}</div>
						</div>
					</div>
				</div>
				<div class="middleBottem">
					<div class="left-item-title">{{$t('platform.Events')}}</div>
					<div class="middleBottem-body">
						<div v-for="(item,index) in logs" :key="index" class="middleBottem-Item">
							<div class="ItemFirst item">
								<img style="width:2rem; height:2rem; margin-top:0.25rem;" src="../assets/img/platform/cuo.svg"/>
								<div v-show="$store.state.lang === 1">[{{item.msgCode}}]{{item.event}}</div>
								<div v-show="$store.state.lang === 0">[{{item.msgCode}}]{{item.msgEn}}</div>
							</div>
							<div class="ItemTwo item">{{item.machineNameEn}}</div>
							<div class="ItemThree item">{{item.createTime | formatDate}}</div>
							<div class="ItemFour item" v-if="item.duration">{{item.duration}}s</div>
							<div class="ItemFour item" v-else></div>
							<div class="ItemFive item">
								<img v-show="item.duration" style="width:2rem; height:2rem; margin-top:0.25rem;" src="../assets/img/platform/dui.svg"/>
							</div>
						</div>
						
					</div>
				</div>
			</div>
			<div class="body-right">
				<div class="rightTop">
					<div class="left-item-title">{{$t('platform.Output')}}</div>
					<div>
						<div class="output">
							<div class="output-title">{{$t('platform.TotalOutput')}}</div>
							<div>
								<div class="output-item">
									<div class="flexo" v-for="(item,index) in output" :key="index">
										<div class="fraction">
											<div :class="{blue:index<3,yellow:index>=3}">{{item}}</div><div>{{outputTime[index]}}</div>
										</div>
										<div v-if="index !== 5" class="divisionplus">/</div>
									</div>
									<div class="percent">{{percentage}}%</div>
								</div>
							</div>
						</div>
						<div>
							<div class="output-title">{{$t('platform.EquipmentOutput')}}</div>
							<div class="equipment-box">
								<div class="equipment" id="equipment" :style="{width:'26rem',height:'20rem'}"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="rightBottom">
					<div class="left-item-title">{{$t('platform.Average')}}</div>
					<div class="dashboardUl">
						<div v-for="item in 16" :key="item">
							<div class="dashboard" :id="'box'+item" :style="{width:'6rem',height:'4.7rem',margin:'0.7rem 0 0 0'}"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//引入转换时间文件
	import { formatDate } from '../assets/js/date.js'

	export default {
		data() {
			return {
				shopId:null,
				websock: null,
				showColor:1,//中英文切换
				statistics:[],//左上实际值与预测值数据
				num:6,
				//中间机器的图片
				images:[
					require('../assets/img/platform/stateXu.png')
				,
					require('../assets/img/platform/stateGreen.png')//1是运行 statelYellow
				,
					require('../assets/img/platform/stateBlue.png')
				,
					require('../assets/img/platform/stateRed.png')
				,
					require('../assets/img/platform/stateBlack.png')
				,   
					require('../assets/img/platform/stateHui.png')
				],
				machines:[],//中间上面的数据
				logs:[],//中间下面的数据
				run:[],//运行
				err:[],//故障
				tool:[],

				macineName:[],//左下echarts图表数据
				allTime:'',//左下echarts中心总数

				output:[],//右上实际值与预测值
				outputTime:[],//产量时间
				rightUpperYZh:[],//右上echarts图表y轴
				rightUpperYEn:[],
				rightUpperSeries:[],//右上echarts图表x轴
				percentage:'',

				equipmentRhythmTime:[],//右下数据
				// 当前时间时间戳
				nowTime: '',
				time: ''
			}
		},
		created() {//找shopId
			let defaultShopId = localStorage.getItem("defaultShopId")
			this.shopId = Number(defaultShopId)
		},
		mounted(){
			this.getUserId()
		},
		methods: {
			// 语言切换
			langChage(l){
				if (l === 1){
					this.$store.state.lang = 1
					this.$i18n.locale = 'zh'
					localStorage.lang = 1
				} else {
					this.$store.state.lang = 0
					this.$i18n.locale = 'en'
					localStorage.lang = 0
				}
				this.leftLower()
				this.rightUpper()
				this.rightLower()
			},
			// 验证用户信息
			getUserId() {
				let _this = this
				this.axios({
					method: 'get',
					url: '/url/selectChooseShop',
					params:{
					language: _this.$store.state.lang,
					shopId: _this.shopId
					}
				}).then(function(res){
					if (res.data.success === 'true') {
						if (res.data.belong === 1) {
							_this.initWebSocket()
							_this.getServeTime()
						} else{
							_this.$router.push({path: '/login', name: 'login'})
						}
						
					} 
				})
			},
			//实时时间
			getServeTime(){
				let _this = this
				this.axios({
					method: 'POST',
					url: '/url/getServerTime'
				}).then(function (res) {
					_this.nowTime = res.data
					_this.startTime()
				})
			},
			startTime(){
				let _this = this
				this.timeRun = setInterval(function(){
					var time = new Date(_this.nowTime);
					var y = time.getFullYear();
					var m = time.getMonth()+1;
					var d = time.getDate();
					var h = time.getHours();
					var mm = time.getMinutes();
					var s = time.getSeconds();
					_this.time = y+'/'+m+'/'+d+' '+h+':'+_this.checkTime(mm)+':'+_this.checkTime(s);
					_this.nowTime += 1000
				},1000)
			},
			checkTime(i){
				if (i<10) {
					i="0" + i
				}
				return i
			},
			leftUpper(){//左上echarts init
			
				let _this = this
				let chartArr = document.querySelectorAll('.chart')
				let chartArr2 = document.querySelectorAll('.chart2')
				let arr = []
				let arr2 = []
				for (let i = 0; i < chartArr.length; i++) {
						arr.push(_this.$echarts.init(chartArr[i])) 
						arr2.push(_this.$echarts.init(chartArr2[i])) 
					}
				
				arr.forEach((item,index) =>{
					let bluearr = []
					_this.statistics[index].beforeList.forEach((it)=>{
						bluearr.push(it.percentage)
					})
					item.setOption({
					color: ['rgba(42, 130, 228, 1)'],
					tooltip : {
						trigger: 'axis',
						axisPointer : {            // 坐标轴指示器，坐标轴触发有效
							type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						top:'0%',
						bottom: '0%'
					},
					xAxis : [
						{
							show:false,
							type : 'category',
							// data : ['8:30', '9:30', '10:30'],
							axisTick: {
								alignWithLabel: true
							}
						}
					],
					yAxis : [
						{
							show:false,
							type : 'value'
						}
					],
					series : [
						{
							name:'直接访问',
							type:'bar',
							barWidth: 2,
							data:bluearr
						}
					]
				})
				})
				
				arr2.forEach((item,index) =>{
					let yellowarr = []
					_this.statistics[index].forList.forEach((it)=>{
						yellowarr.push(it.percentage)
					})

					item.setOption({
					color:['rgba(207, 228, 42, 1)'],
					tooltip : {
						trigger: 'axis',
						axisPointer : {            // 坐标轴指示器，坐标轴触发有效
							type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						top:'0%',
						bottom: '0%'
					},
					xAxis : [
						{
							show:false,
							type : 'category',
							// data : ['8:30', '9:30', '10:30'],
							axisTick: {
								alignWithLabel: true
							}
						}
					],
					yAxis : [
						{
							show:false,
							type : 'value'
						}
					],
					series : [
						{
							name:'直接访问',
							type:'bar',
							barWidth: 2,
							data:yellowarr
						}
					]
				})
				})
				
			},
			leftLower(){//左下echarts init
				// let _this = this
				let chartTotal = this.$echarts.init(document.getElementById('echartsTotal'));
				let scale = 1;
				// let echartData = [
				// 	{
				// 		value: 1854,
				// 		name: 'TBM005'
				// 	}, {
				// 		value: 3515,
				// 		name: 'TBM101'
				// 	}, {
				// 		value: 2515,
				// 		name: 'TBM102'
				// 	}, {
				// 		value: 7854,
				// 		name: 'TBM105'
				// 	}
				// ]
				
				let echartData = this.macineName.map((item) =>{
						return {
							value:item.durationTime,
							name:item.macineName
						}
					})
				let col =  '#0b5263'//圆的第二条线
				if(echartData.length === 0){
					echartData = [{
						value: 0,
						name: 'null'
					}]
					col = '#021724'
				}
				let rich = {
					yellow: {//value数字
						color: "#ffc72b",
						fontSize: 12 * scale,
						padding: [5, 4],
						align: 'center'
					},
					total: {//圆中心的数字
						color: "#ffc72b",
						fontSize: 18 * scale,
						// padding: [0, 0],
						align: 'center'
					},
					white: {//控制大学名称的字体样式
						color: "#fff",
						align: 'center',
						fontSize: 8 * scale,
						padding: [4, 0]
					},
					blue: {//百分比
						color: '#49dff0',
						fontSize: 8 * scale,
						align: 'center'
					},
					hr: {//圆的第二条线
						borderColor: '#0b5263',
						width: '100%',
						borderWidth: 1,
						height: 0,
					}
				}

				chartTotal.setOption({
					title: {
						show:true,
						text:this.$t('platform.TotalTimes'),
						left:'center',
						top:'53%',
						padding:[8,0],
						textStyle:{
							color:'#fff',
							fontSize:10*scale,
							align:'center'
						}
					},
					legend: {
						show:true,
						selectedMode:false,//是否可以通过点击图例改变系列的显示状态
						formatter: function() {
							let total = 0; //各科正确率总和
							// let averagePercent; //综合正确率
							echartData.forEach(function(value) {
								total += value.value;
							});
							return '{total|' + total + '}';
						},
						data: [echartData[0].name],
						left: 'center',
						top: 'center',
						icon: 'none',
						align:'center',
						textStyle: {
							color: "#fff",
							fontSize: 16 * scale,
							rich: rich
						},
						z:100
					},
					series: [{
						name: '总考生数量',
						type: 'pie',
						radius: ['42%', '50%'],//控制圆的大小
						hoverAnimation: false,
						color: ['rgb(60,144,247)','rgb(85, 191, 192)','rgb(94, 190, 103)','rgb(244, 205, 73)','rgb(224, 86, 103)','rgb(124, 75, 216)','rgb(60,144,247)'],
						label: {
							normal: {
								formatter: function(params) {
									var total = 0; //考生总数量
									var percent = 0; //考生占比
									echartData.forEach(function(value) {
										total += value.value;
									});
									percent = ((params.value / total) * 100).toFixed(1);
									if(params.data.name === 'null'){
										return ''
									}else{
										return '{white|' + params.name + '}\n{hr|}\n{yellow|' + params.value + '}\n{blue|' + percent + '%}';
									}
									
								},
								rich: rich
							},
						},
						labelLine: {//圆的第一条线
							normal: {
								length: 20 * scale,
								length2: 0,
								lineStyle: {
									color: col
								}
							}
						},
						data: echartData
					}]
				})
			},
			rightUpper(){//右上echarts init
				let _this = this
				let equipment = this.$echarts.init(document.getElementById('equipment'));
				let interN = []
				if(_this.$store.state.lang === 1){
					interN = _this.rightUpperYZh
				}else{
					interN = _this.rightUpperYEn
				}
				equipment.setOption({
					grid: {
						// left: '0%',
						top:'1%',
						right:'5%',
						bottom: '0',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						axisLabel:{
							fontSize:8
						},
						boundaryGap: [0, 0.01]
					},
					yAxis: {
						type: 'category',

						axisLabel:{  
							interval:0,//横轴信息全部显示   
							fontSize:8
						},
						data: interN
					},
					series: [
						{
							name: '2011年',
							color:'rgb(60, 144, 247)',
							barWidth: 5,
							type: 'bar',
							data: _this.rightUpperSeries
						}
					]
				})
			},
			rightLower(){//右下echarts init
					
				let _this = this
				let dashboardArr = document.querySelectorAll('.dashboard');
				let brr = []
				for (let i = 0; i < this.equipmentRhythmTime.length; i++) {
					brr.push(_this.$echarts.init(dashboardArr[i])) 
				}
				let equipmentName = []
				_this.equipmentRhythmTime.forEach(item=>{
					if(item.equipmentName){
						equipmentName.push(item.equipmentName)
					}else{
						if(_this.$store.state.lang){
							equipmentName.push(item.nameZh)
						}else{
							equipmentName.push(item.nameEn)
						}
					}
				})
				brr.forEach((item,index) =>{
					item.setOption({
						series: [
							{
								name: '业务指标',
								type: 'gauge',
								min: 0,//最小值
								max: 100,//最大值
								splitNumber: 10,//分成几份
								radius: '100%',//最外面圆弧的百分比
								title:{//标题
									color:'rgb(245, 245, 245)',
									fontSize:5,//5
									padding:[47,0,0,0]
								},
								pointer:{//指针
									// length:80%,长度
									width:2,//宽度
									
								},
								itemStyle:{//指针样式
									color:'rgb(73, 157, 248)',//颜色
								},
								axisLine: {            
									lineStyle: {       
										width: 4,//控制圆弧厚度
										color:[[_this.equipmentRhythmTime[index].checkCacul*0.01, 'rgb(73, 157, 248)'], [1, 'rgb(245, 245, 245)']]//仪表盘颜色
									}
								},
								axisTick: { // 控制小刻度
									length: 0,// 控制线长
									lineStyle: { // 控制线条样式
										color: 'auto'
									}
								},
								splitLine: {// 控制大刻度
									length: 0,         
									lineStyle: {       
										color: 'auto'
									}
								},
								axisLabel: {//刻度数字(透明)
									color: 'rgba(0,0,0,0)',
								},
								detail: {//显示百分比
									formatter:'{value}%',
									color: '#fff',
									fontSize:7,
									offsetCenter:[0,9]//相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，
														//第二项是垂直方向的偏移。可以是绝对的数值，也可以是相对于仪表盘半径的百分比。
								},
								data: [{value: _this.equipmentRhythmTime[index].checkCacul , name:equipmentName[index]}]//指针
							}
						]
					})
				})
			},
			WSocketApi(ls,lx,ms,mx,rs,rx){
				//左上
				let resData = ls
				let arr = []
				for(let item in resData){
					arr.push(resData[item])
				}
				arr.forEach((item)=>{
					item.beforeList.forEach(it=>{
						if(it.percentage===0){
							it.percentage = '-'
						}
					})
					item.forList.forEach(it=>{
						if(it.percentage===0){
							it.percentage = '-'
						}
					})
				})
				this.statistics = arr
				// setTimeout(() => {
					this.leftUpper()
				// }, 100);	

				//左下
				let macineNameArr = []
				lx.data.forEach(item => {
					if(item.durationTime !== 0){
						macineNameArr.push(item)
					}
				})
				this.macineName = macineNameArr
				this.allTime = lx.allTime
				this.leftLower()
				//中上
				if(ms){
					this.machines = ms
					this.run = []
					this.err = []
					ms.forEach(item=>{
						if(item.machineStatus === 1){
							this.run.push(item.machineStatus)
						}else if(item.machineStatus === 3){
							this.err.push(item.machineStatus)
						}
					})
				}
				//中下
				let dataLogs = []
				mx.forEach(item=>{
					dataLogs.push(item)
				})
				this.logs = dataLogs
				//右上
				let msg = rs.msg
				let crr = []//时间
				let actual = []//实际值
				let act = []
				let predicted = []//预测值
				let pred = []
				msg.forEach((item)=>{
					crr.push(item.time.slice(45,50))

					actual.push(item.actual)//实际值
					predicted.push(item.predicted)//预测值
				})
				act = actual.slice(0,3)
				pred = predicted.slice(3,6)
				pred.forEach(item =>{
					act.push(item)
				})
					let outputarr = []
					outputarr=act.map(item=>{
					if(item === 0){
							item = '-'
					}
					return item
				})
				this.outputTime = crr
				this.output = outputarr
			
				let TireInfoMachines = rs.TireInfoMachines
				let arrsZh = []
				let arrsEn = []
				let brr = []
				TireInfoMachines.forEach((item) => {
					arrsZh.push(item.nameZh) 
					arrsEn.push(item.nameEn) 
					
					brr.push(item.num)
				})
				this.rightUpperYZh = arrsZh
				this.rightUpperYEn = arrsEn
				this.rightUpperSeries = brr

				let cent = Math.abs(parseInt(rs.percentage*100))
				if(cent === 0){
					cent = '0'
				}
				this.percentage = cent
				this.rightUpper()

				//右下
				this.equipmentRhythmTime =rx
				this.rightLower()
			},
			initWebSocket(){ 
				let _this = this
				_this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+_this.$store.state.newroute+ "/websocket-reloadstatistic")
				// 接收服务器发来的消息
				_this.websock.onmessage = function (e) {
					let abv = JSON.parse(e.data)//通过 e.data获取数据
					_this.WSocketApi(JSON.parse(abv.screenData),JSON.parse(abv.bigReloadingData),abv.machines,abv.alertLogList,JSON.parse(abv.outPutStatisticsData),JSON.parse(abv.equipmentRhythmTimeData))
					
				}
				// 连接建立之后执行send方法发送数据
				_this.websock.onopen = function () { 
					var param = {
						'shopId': 2
					}
					var params = JSON.stringify(param)
					// 向服务器发送消息
					_this.websock.send(params)
				}
				// 连接建立失败重连
				_this.websock.onerror = function () {
					_this.listLoading = false
					_this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+_this.$store.state.newroute+ "/websocket-reloadstatistic")
				}
				// 关闭
				_this.websock.onclose = function () {
					_this.websock = null
				}
			}
		},
		filters: {//转换时间发方法
			timers (time) {
				if (time === null || time === '') {
					return ''
				}
				var date = new Date(time)
				return formatDate(date, 'yyyy/MM/dd hh:mm:ss')
			},
			formatDate (time) {
				if (time === null || time === '') {
					return ''
				}
				var date = new Date(time)
				return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
			},
			formatDateTime (time) {
				if (time === null || time === '') {
					return ''
				}
				var date = new Date(time)
				return formatDate(date, 'hh:mm')
			}
		}
	}
</script>

<style scoped>
	.flexo{
		display: flex;
	}
	.content {
		padding: 4vh;
		height: 92vh;
		background-color:#021724;
		color: #ffffff;
	}
	.header{
		height: 3rem;
		display: flex;
		justify-content: space-between;
		text-align: center;
		margin-bottom: 2rem;
		line-height: 3rem;
		font-size: 2rem;
	}
	.header-left{
		background-color: black;
		width: 20%;
		border-radius: 0.6rem;
	}
	.header-middle{
		background-color: black;
		width: 61%;
		border-radius: 0.6rem;
	}
	.header-right{
		background-color: black;
		width: 18%;
		border-radius: 0.6rem;
	}
	.show{
		cursor: pointer;
	}
	.purple{
		color: rgba(103, 114, 229, 1);
	}
	.body{
		display: flex;
	}
	.body-left{
		width: 25%;
	}

/* 左上 */
	.left-item-title{
		background-color: black;
		height: 2rem;
		font-size: 1.4rem;
		line-height: 2rem;
		font-weight: bold;
		text-indent: 0.5rem;
	}
	.left-item-content{
		padding: 1rem 1rem;
	}
	.statistics-item-title{
		padding: 0.5rem 0;
		font-size: 1rem;
		line-height: 1.5rem;
		font-weight: bold;
	}
	.statistics-item{
		display: flex;
		font-size: 0.8rem;
	}
	.fract{
		text-align: center;
		width: 2.4rem;
	}
	.chart-p{
		position: relative;
	}
	.chart-absolute{
		display: flex;
		position: absolute;
		bottom: 0.3rem;
	}
	.chart{
		margin-left: 0.6rem;
	}
	.division{
		line-height: 2rem;
		margin: 0 0.3rem;
	}
	.blue{
		color: rgba(42, 130, 228, 1);
	}
	.yellow{
		color:rgba(207, 228, 42, 1);
	}
	.Percentage{
		width: 2.5rem;
		height: 2.5rem;
		margin-left: 4.8rem;
		border:0.07rem solid rgba(255, 255, 255, 1);
		border-radius: 50%;
		text-align: center;
		line-height: 2.5rem;
		font-size: 1rem;
	}
/* 左上 */
/* 左下 */
	.chartTotal{
		width: 28rem;
		margin: 0 auto;
		position: relative;
	}
	.allTime{
		width: 100%;
		/* height: 3rem; */
		line-height: 3rem;
		font-size: 2rem;
		/* color: rgb(244, 205, 73); */
		color: #ffffff;
		text-align: center;
		position: absolute;
		left:50%;
		top:50%;
		margin-left: -50%;
		margin-top: -3rem;
	}
	.TotalTime{
		font-size: 1.4rem;
	}
	.TotalItem{
		width: 13rem;
		display: flex;
		justify-content: space-between;
		height: 2.6rem;
		font-size: 0.9rem;
		line-height: 2.6rem;
	}
	.TotalItem-left{
		display: flex;
	}
	.TotalItem-circular{
		margin: 1rem 0.3rem;
		width: 0.6rem;
		height: 0.6rem;
		border-radius: 50%;
		background-color: rgb(60,144,247);
	}
/* 中上 */
	.body-middle{
		width: 50%;
		height: 1rem;

	}
	.middleTop-title{
		display: flex;
		justify-content: center;
	}
	.middleTopTitle{
		border-radius: 0.4rem;
		height: 2.5rem;
		font-size: 1.2rem;
		line-height: 2.5rem;
		margin-left: 0.5rem;
		padding: 0 1rem;
	}
	.middleTopTitle-one{
		background-color:rgba(81, 20, 20, 1);
	}
	.middleTopTitle-two{
		background-color:rgba(102, 249, 102, 1);
		color:rgba(19, 13, 13, 1);
	}
	/* .middleTopTitle-three{
		background-color:rgba(140, 140, 14, 1);
		color:rgba(19, 13, 13, 1);
	} */
	.middleTopTitle-four{
		background-color:rgba(178, 0, 0, 1);
	}
	.middleTopTitle-five{
		background-color:rgba(255, 255, 0, 1);
		color:rgba(19, 13, 13, 1);
	}
	.middleTop-body{
		width:	48rem;
		height:34rem;
		margin: 3rem auto;
		display:flex;
		justify-content: left;
		flex-flow: row wrap;
	}
	.middleTopBody-item{
		position:relative;
		margin-left: 4%;
	}
	.icon{
		position:absolute;
		right:0;
		top:0;
	}
	.type{
		width:10rem; 
		text-align:center; 
		font-size:1.5rem;
		line-height:2.2rem;
	}
	.middleBottem{
		padding: 0 2rem;
	}
	.middleBottem-body{
		margin-top:0.7rem;
	}
	.middleBottem-Item{
		display: flex;
		line-height: 2.5rem;
		margin-bottom: 0.2rem;
		font-size: 1rem;
	}
	.item{
		height: 2.5rem;
		text-align: center;
	}
	.ItemFirst{
		width: 55%;
		display: flex;
		background-color: rgba(171, 203, 229, 0.89);
		text-indent: 0.5rem;
		color: rgba(0, 0, 0, 1);
		border-radius:0.3rem 0 0 0.3rem;
	}
	.ItemTwo{
		width: 10%;
		background-color: rgba(50, 90, 112, 1);
	}
	.ItemThree{
		width: 22%;
		background-color: rgba(33, 59, 74, 1);
		margin-right: 0.5%;
	}
	.ItemFour{
		width: 8.5%;
		background-color: rgba(33, 59, 74, 1);
	}
	.ItemFive{
		width: 4%;
		background-color: rgba(20, 43, 57, 1);
		border-radius: 0 0.3rem 0.3rem 0;
	}
	/* 右 */
	.body-right{
		width: 25%;
		background-color: black;
		height: 1rem;
	}
	/* 右上 */
	.output{
		padding-top: 0.8rem;
	}
	.output-title{
		font-weight: bold;
		font-size: 1rem;
		line-height: 150%;
		margin: 1rem 0 0.8rem;
	}
	.output-item{
		display: flex;
		font-size: 1.2rem;
		line-height: 2rem
	}
	.fraction{
		width: 3rem;
		text-align: center;
	}
	.percent{
		width: 3rem;
		height: 3rem;
		margin: 0.5rem 0 0 1rem;
		border:0.07rem solid rgba(255, 255, 255, 1);
		border-radius: 50%;
		text-align: center;
		line-height: 3rem;
		font-size: 1rem;
	}
	.divisionplus{
		line-height: 3rem;
		margin: 0 0.4rem;
	}
	.equipment-box{
		margin:0 0 1.5rem 1rem;
	}

	/* 右下 */
	.dashboardUl{
		/* margin-top:1rem; */
		padding: 0 1.5rem;
		display:flex;
		justify-content: space-around;
		flex-wrap: wrap ;
	}
	/* .dashboard{
		margin-top: 1rem;
	} */
</style>